import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { AddWalletsModal } from "./AddWalletsModal ";

export const AddWalletsBtn = observer(() => {
  const { actionModals } = useStores();

  const openModalHandler = () => {
    actionModals.open(() => <AddWalletsModal />, {
      title: "Добавить адреса",
      width: "600px",
    });
  };

  return <CustomButton onClick={openModalHandler}>Добавить адрес</CustomButton>;
});
